import { lazy } from "react";
const TechnicalIssuesPage = lazy(() => import("./pages/TechnicalIssuesPage"));
export { TechnicalIssuesPage };

export const technicalIssuesRoutes = [
  {
    path: "/technical-issues",
    element: <TechnicalIssuesPage />,
  },
];
